import { render, staticRenderFns } from "./PurchasesMonitoring.vue?vue&type=template&id=6e9fbbb5"
import script from "./PurchasesMonitoring.vue?vue&type=script&lang=js"
export * from "./PurchasesMonitoring.vue?vue&type=script&lang=js"
import style0 from "./PurchasesMonitoring.vue?vue&type=style&index=0&id=6e9fbbb5&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports